import { laceOfVerticalPartsRight } from './parts/laceParts'
import { drawWithImagePatternWrapper } from 'src/util/canvasImagePattern'

const laceOfVerticalPartsLeft = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.lineWidth = 0.8
  ctx.beginPath()
  ctx.moveTo(265 + x, 208 + y) // 右上
  ctx.quadraticCurveTo(268 + x, 217 + y, 253 + x, 234 + y) // 左上
  ctx.quadraticCurveTo(252 + x, 238 + y, 257 + x, 240 + y) // 左下
  ctx.quadraticCurveTo(275 + x, 227 + y, 265 + x, 208 + y) // 右上
  ctx.fill()
  // 上側面
  ctx.moveTo(265 + x, 208 + y) // 右上
  ctx.quadraticCurveTo(270 + x, 221 + y, 253 + x, 236 + y) // 左下
  ctx.stroke()
  ctx.closePath()
}

const laceOfNetWebDouble2 = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.lineWidth = 0.8
  ctx.beginPath()
  ctx.moveTo(259 + x, 239 + y) // 右上
  ctx.quadraticCurveTo(261 + x, 243 + y, 261 + x, 245 + y) // 右下
  ctx.quadraticCurveTo(249 + x, 249 + y, 238 + x, 247 + y) // 左下
  ctx.quadraticCurveTo(241 + x, 238 + y, 241 + x, 240 + y) // 左上
  ctx.quadraticCurveTo(250 + x, 242 + y, 259 + x, 239 + y) // 右上
  ctx.fill()
  // // 上側面
  ctx.moveTo(241 + x, 242 + y) // 右上
  ctx.quadraticCurveTo(250 + x, 244 + y, 259 + x, 241 + y) // 右上
  ctx.stroke()
  ctx.closePath()
}

const laceOfNetWebDouble3 = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.lineWidth = 0.8
  ctx.beginPath()
  ctx.moveTo(309 + x, 140 + y) // 左下
  ctx.quadraticCurveTo(323 + x, 147 + y, 345 + x, 150 + y) // 右下＿外
  ctx.quadraticCurveTo(367 + x, 150 + y, 361 + x, 122 + y) // 右_上＿外
  ctx.quadraticCurveTo(358 + x, 127 + y, 358 + x, 127 + y) // 右_上＿内
  ctx.quadraticCurveTo(357 + x, 143 + y, 351 + x, 143 + y) // 右下＿内
  ctx.quadraticCurveTo(332 + x, 141 + y, 317 + x, 133 + y) // 左上
  ctx.quadraticCurveTo(309 + x, 132 + y, 309 + x, 140 + y) // 左上
  ctx.fill()
  // // 上側面
  ctx.moveTo(315 + x, 135 + y) // 右上
  ctx.quadraticCurveTo(338 + x, 146 + y, 355 + x, 145 + y) // 右下
  ctx.quadraticCurveTo(363 + x, 134 + y, 360 + x, 124 + y) // 右上
  ctx.stroke()
  ctx.closePath()
}

const laceOfNetWebDouble4 = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.lineWidth = 0.8
  ctx.beginPath()
  ctx.moveTo(303 + x, 196 + y) // 左上
  ctx.quadraticCurveTo(307 + x, 204 + y, 307 + x, 204 + y) // 左下
  ctx.quadraticCurveTo(341 + x, 158 + y, 349 + x, 156 + y) // 右下
  ctx.quadraticCurveTo(355 + x, 150 + y, 355 + x, 144 + y) // 右上
  ctx.quadraticCurveTo(338 + x, 150 + y, 303 + x, 196 + y) // 左上
  ctx.fill()
  // 上側面
  ctx.moveTo(303 + x, 200 + y) // 右上
  ctx.quadraticCurveTo(338 + x, 154 + y, 355 + x, 146 + y) // 左上
  ctx.stroke()
  ctx.closePath()
}

const laceOfNetWebDouble5 = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.lineWidth = 0.8
  ctx.beginPath()
  ctx.moveTo(295 + x, 154 + y) // 左上
  ctx.quadraticCurveTo(297 + x, 163 + y, 297 + x, 163 + y) // 左下
  ctx.quadraticCurveTo(302 + x, 159 + y, 310 + x, 165 + y) // 右下
  ctx.quadraticCurveTo(315 + x, 157 + y, 315 + x, 155 + y) // 右上
  ctx.quadraticCurveTo(306 + x, 151 + y, 295 + x, 154 + y) // 右上
  ctx.fill()
  // // 上側面
  ctx.moveTo(295 + x, 157 + y) // 左上
  ctx.quadraticCurveTo(306 + x, 153 + y, 315 + x, 159 + y) // 右上
  ctx.stroke()
  ctx.closePath()
}

export const w36Web = async (
  ctx: CanvasRenderingContext2D,
  edgeColor: string,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2?: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // lace_1 ここから
  ctx.fillStyle = laceColor

  // ウェブ_縦
  const drawVerticalWeb = () => {
    ctx.beginPath()
    ctx.moveTo(250, 212) // 左＿上
    ctx.quadraticCurveTo(273, 285, 312, 354) // 左＿下
    ctx.quadraticCurveTo(332, 331, 342, 306) // 右＿下
    ctx.quadraticCurveTo(313, 241, 293, 150) // 右＿上
    ctx.quadraticCurveTo(265, 189, 251, 212) // 左＿上
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  const verticalWebColor = webColor2 || webColor
  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawVerticalWeb, verticalWebColor)

  ctx.fillStyle = webColor
  // ヘリ革左ここから
  ctx.fillStyle = edgeColor
  ctx.beginPath()
  ctx.moveTo(250, 212) // 上＿外
  ctx.quadraticCurveTo(273, 285, 313, 355) // 左＿下
  ctx.quadraticCurveTo(316, 346, 316, 346) // 下＿内
  ctx.quadraticCurveTo(275, 267, 256, 203) // 上＿内
  ctx.quadraticCurveTo(250, 212, 250, 212) // 上＿外
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // ヘリ革右ここから
  ctx.beginPath()
  ctx.moveTo(287, 163) // 上＿内
  ctx.quadraticCurveTo(301, 229, 339, 314) // 下＿内
  ctx.quadraticCurveTo(342, 307, 344, 307) // 右＿下
  ctx.quadraticCurveTo(313, 241, 293, 150) // 上＿外
  ctx.quadraticCurveTo(287, 163, 287, 163) // 上＿内
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // ヘリ革ここまで

  // stitchここから
  ctx.lineWidth = 1.1
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // 縦＿左
  ctx.moveTo(260, 209) // 右上
  ctx.quadraticCurveTo(282, 277, 322, 353) // 左下
  // 縦＿右
  ctx.moveTo(283, 157) // 右上
  ctx.quadraticCurveTo(300, 234, 335, 310) // 左下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  // laceここから
  ctx.fillStyle = laceColor
  // 縦パーツ周りの革紐
  laceOfVerticalPartsLeft(ctx, laceColor, -5, -24)
  laceOfVerticalPartsLeft(ctx, laceColor, 0, 0)
  laceOfVerticalPartsLeft(ctx, laceColor, 10, 28)
  laceOfVerticalPartsLeft(ctx, laceColor, 20, 60)
  laceOfVerticalPartsLeft(ctx, laceColor, 29, 83)
  laceOfVerticalPartsLeft(ctx, laceColor, 40, 111)

  // MEMO：基本前面にしておきたい部分の内、一部背面に持っていきたい部分↓
  // ネットウェブ
  // 6段目
  laceOfNetWebDouble3(ctx, laceColor, 18, 138)
  // 縦パーツ右
  laceOfVerticalPartsRight(ctx, laceColor, 38, 110)
  // ネット部分
  laceOfNetWebDouble5(ctx, laceColor, 0, 0)
  laceOfNetWebDouble5(ctx, laceColor, 5, 27)
  laceOfNetWebDouble5(ctx, laceColor, 12, 55)

  laceOfNetWebDouble2(ctx, laceColor, 0, 0)
  laceOfNetWebDouble2(ctx, laceColor, 10, 28)
  laceOfNetWebDouble2(ctx, laceColor, 23, 58)
  laceOfNetWebDouble2(ctx, laceColor, 34, 80)
  laceOfNetWebDouble2(ctx, laceColor, 49, 107)
  laceOfNetWebDouble4(ctx, laceColor, -100, 82)
  laceOfNetWebDouble4(ctx, laceColor, -89, 110)
  laceOfNetWebDouble4(ctx, laceColor, -78, 140)
  laceOfNetWebDouble4(ctx, laceColor, -68, 164)
  laceOfNetWebDouble4(ctx, laceColor, -55, 190)
}

export const w36WebCrossLace = (ctx: CanvasRenderingContext2D, laceColor: string): void => {
  ctx.lineWidth = 0.7
  // 左上 - 右下方向
  ctx.beginPath()
  ctx.fillStyle = laceColor
  ctx.strokeStyle = '#282828'
  ctx.moveTo(256, 180) // 左上＿上
  ctx.quadraticCurveTo(258, 188, 260, 188) // 左上＿下
  ctx.quadraticCurveTo(276, 180, 303, 179) // 右下＿下
  ctx.quadraticCurveTo(304, 175, 300, 171) // 右下＿上
  ctx.quadraticCurveTo(276, 171, 256, 180) // 左上＿上
  ctx.fill()
  ctx.moveTo(260, 187)
  ctx.quadraticCurveTo(276, 177, 303, 178)
  ctx.stroke()
  ctx.closePath()

  // 右上 - 左下方向
  ctx.beginPath()
  ctx.fillStyle = laceColor
  ctx.strokeStyle = '#282828'
  ctx.moveTo(277, 157) // 右上_上
  ctx.quadraticCurveTo(267, 190, 249, 216) // 左下_上
  ctx.quadraticCurveTo(247, 220, 255, 221) // 左下_下
  ctx.quadraticCurveTo(273, 204, 282, 164) // 右上_下
  ctx.quadraticCurveTo(280, 155, 277, 157) // 右上_上
  ctx.fill()
  ctx.moveTo(277, 157) // 右上_上
  ctx.quadraticCurveTo(269, 193, 249, 217) // 左下_上
  ctx.stroke()
  ctx.closePath()
}
